import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
    name: 'xenaDate',
    standalone: false
})
export class XenaDatePipe implements PipeTransform {

  private datePipe: DatePipe;
  
  constructor(@Inject(LOCALE_ID) private locale: string) {
    this.datePipe = new DatePipe(locale);
  }

  transform(value: Date, ...args: unknown[]): string {
    const customFormat = environment.i18n.date[this.locale];

    if(customFormat != null) {
      return this.datePipe.transform(value, customFormat);
    } else {
      return this.datePipe.transform(value, 'shortDate');
    }
    
  }

}
